
// import * as Redirect from 'react-router-dom'



// function Link(props) 
// {
//  return <Redirect.Link
//         {...props}>
//         {props.children}
//       </Redirect.Link>
//     }


// export default Link;

import { Link as RouterLink, useParams } from "react-router-dom";

function Link({ to, ...props }) {
  const { country } = useParams();

  let finalPath = to.startsWith("/") ? to.slice(1) : to;

  if (!finalPath.startsWith(`${country}/`)) {
    finalPath = `/${country}/${finalPath}`;
  } else {
    finalPath = `/${finalPath}`;
  }

  return <RouterLink to={finalPath} {...props} />;
};

export default Link;
